import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from "react-query";
import { api } from "../../../../api";
import toast from "react-hot-toast";
import { useCustomToast } from "../../../../components/customtoast/CustomToastProvider";
import { ScaleLoader } from "react-spinners";
import CustomDropdown from "../../../../components/Global/CustomDrpdown";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { profile } from "../../../../api/profile";
import { formatDate } from './../../../../utils/dateFormatter';

const useDebounce = (fn, delay) => {
  let timeout;
  // return function that takes arg and apply to the function
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
};

function AddEducation({ closeModal, refetchEducation, refetchStatus }) {
  const { t } = useTranslation();
  const customToast = useCustomToast();
  const user = JSON.parse(sessionStorage.getItem('user'))?.user
  const [institutionSearch, setInstitutionSearch] = useState('')
  const [searchInstitutionLoading, setSearchInstitutionLoading] = useState(false)
  const [searchCourseLoading, setSearchCourseLoading] = useState(false)
  const [institutions, setInstitutions ] = useState([])
  const [courses, setCourses] = useState([]);
  const [startDate_, setStartDate_] = useState('');
   
  // fetch data
  const { isLoading: institutionLoading, refetch} = useQuery(
    "get-institution",
    async () => {
         return await profile.getInstitutionsv2(institutionSearch)
     },
    {
      retry: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: true,
      onSuccess: response => {
          setInstitutions(response?.data?.map( ins => {
             return {label: ins?.name, value: ins?.id}
          }))
      }
    }
  );

  const getInstitutionsMutation = useMutation(profile.getInstitutionsv2,
    {
      onSuccess: response => {
          setInstitutions(response?.data?.map( ins => {
             return {label: ins?.name, value: ins?.id}
          }))
      }
    }
  )

  const addInstitutionMutation = useMutation(api.addInstitution, {
     onMutate: () => {
        toast.loading(t('add-education.loading'))
     },
     onError: error => {
        toast.remove()
        toast.error(error?.response?.message)
     },
     onSuccess: data => {
        toast.remove()
        toast.success(t('add-education.success'))
        setOtherInstitution('')
        setIsOthers(false)
        refetch()
        setSelectedInstitutionId(data?.data?.id || "");
        setSelectedInstitution(data?.data?.name || "");
        setInstitutionValid(true);
     }
  })

  const {mutateAsync, isLoading: createEducationLoading} = useMutation(profile.createUserEducationv2)

  // fetch data
  const { isLoading,} = useQuery("get-courses", profile.getCoursesv2, {
    retry: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
     onSuccess: data => {
      setCourses(
        data?.data?.map((ins) => {
          return { label: ins?.title, value: ins?.id };
        })
      );
     }
  });

  const getCoursesMutation = useMutation(profile.getCoursesv2, {
    onSuccess: (response) => {
      setCourses(
        response?.data?.map((ins) => {
          return { label: ins?.title, value: ins?.id };
        })
      );
      setTimeout( () => setSearchCourseLoading(false) , 100 )
    },
  });

  const { data: degrees } = useQuery(
    "get-degree",
     profile.getDegreesv2,
     {
      retry: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      select: response => response?.data
     }
    );

  const { data: classOfDegrees } = useQuery(
    "get-classOfDegrees",
    profile.getClassOfDegreesv2,
    {
      retry: false,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      select: (response) => response?.data,
    }
  );
  // End

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isOthers, setIsOthers] = useState(false)
  const [otherInstitution, setOtherInstitution] = useState('')

  // handle seletced states
  const [selectInstitution, setSelectedInstitution] = useState("");
  const [selectCourse, setSelectedCourse] = useState("");
  const [selectDegree, setSelectedDegree] = useState("");
  // const [selectState, setSelectedState] = useState("");
  const [selectClassOfDegree, setSelectedClassOfDegree] = useState("");
  const [degreeId, setDegreeId] = useState(null);
  const [courseId, setCourseId] = useState(null);
  const [selectInstitutionId, setSelectedInstitutionId] = useState(null);
  const [classOfDegreeId, setClassOfDegreeId] = useState(null);

  // for validation
  const [institutionValid, setInstitutionValid] = useState(true);
  const [courseValid, setCourseValid] = useState(true);
  const [degreeValid, setDegreeValid] = useState(true);
  const [classofDegreeValid, setClassOfDegreeValid] = useState(true);
  const [startDateValid, setStartDateValid] = useState(true);
  const [endDateValid, setEndDateValid] = useState(true);

  // Start of Degree
  const filteredInstitutions = (inputValue) => {
    return institutions?.data
      .filter((institution) =>
        institution.name.toLowerCase().includes(inputValue.toLowerCase())
      )
      .map((i) => ({
        value: i.id,
        label: i.name,
        key: i.id.toString(),
      }));
  };
  // End

  const loadOptions = (inputValue, callback) => {
    callback(filteredInstitutions(inputValue));
  };
  // End

  // Start of Degree filter
  const filteredDegree = (inputValue) => {
    return degrees?.data
      .filter((degree) =>
        degree.name.toLowerCase().includes(inputValue.toLowerCase())
      )
      .map((deg) => ({
        value: deg.id,
        label: deg.name,
        key: deg.id.toString(),
      }));
  };
  const degreeOptions = (inputValue, callback) => {
    callback(filteredDegree(inputValue));
  };
  // End

  // Start of courses filter
  const filteredCourses = (inputValue) => {
    return courses?.data
      .filter((course) =>
        course.title.toLowerCase().includes(inputValue.toLowerCase())
      )
      .map((c) => ({
        value: c.id,
        label: c.title,
        key: c.id.toString(),
      }));
  };
  const courseOptions = (inputValue, callback) => {
    callback(filteredCourses(inputValue));
  };
  // End

  // Start of class of degree filter
  const filteredClassOfDegrees = (inputValue) => {
    return classOfDegrees?.data
      .filter((classOfDegree) =>
        classOfDegree.name.toLowerCase().includes(inputValue.toLowerCase())
      )
      .map((cg) => ({
        value: cg.id,
        label: cg.name,
        key: cg.id.toString(),
      }));
  };
  const classOptions = (inputValue, callback) => {
    callback(filteredClassOfDegrees(inputValue));
  };
  // End

  const createEducation = async (e) => {
    e.preventDefault();

    setInstitutionValid(selectInstitution !== "");
    setCourseValid(selectCourse !== "");
    setDegreeValid(selectDegree !== "");
    setClassOfDegreeValid(selectClassOfDegree !== "");
    setStartDateValid(startDate !== "");
    setEndDateValid(endDate !== "");

    if (!institutionValid || !courseValid || !degreeValid || !classofDegreeValid || !startDate || !endDate) {
      toast.error(t('add-education.validation.all-fields'));
      return;
    }
    else if(!selectInstitutionId){
      return toast.error(t('add-education.validation.select-institution'));
    }
    else{
    let formData = {
      name: selectInstitution,
      degree: selectDegree,
      degree_id: degreeId,
      course: selectCourse,
      course_id: courseId,
      // location: selectState,
      class_of_degree: selectClassOfDegree,
      class_of_degree_id: classOfDegreeId,
      start_date: formatDate(startDate),
      end_date: formatDate(endDate),
      institution: selectInstitution,
      institution_id: selectInstitutionId,
    };

    try {
      toast.loading(t('loading'));
      const response = await mutateAsync({ payload: formData, id: user?.user_id });
      toast.remove();
      customToast.success(response.message);
      sessionStorage.setItem("progress", "education");
      await refetchEducation();
      await refetchStatus();
      closeModal(false);
    } catch (error) {
      toast.remove();
      if (error.response) {
        customToast.error(error.response.data.message);
      } else {
        customToast.error(error.message);
      }
    }
   }
  };

  const addInstitution = () => {
    if(!otherInstitution) toast.error(t('errors.add-institution'))
    else addInstitutionMutation.mutate({
      category: 'other',
      name: otherInstitution,
    })
  }

  const debouncedSearch = useDebounce((input) => {
    getInstitutionsMutation.mutate(input);
    setInstitutionSearch(input);
  }, 1500);

  const handleSearch = React.useCallback(
    (value) => {
      debouncedSearch(value);
    },
    [debouncedSearch]
  );

  const courseDebouncedSearch = useDebounce((input) => {
    getCoursesMutation.mutate(input);
    setInstitutionSearch(input);
  }, 1500);

  const handleCourseSearch = React.useCallback(
    (value) => {
      courseDebouncedSearch(value);
    },
    [debouncedSearch]
  );

  useEffect(() => {
    if (getInstitutionsMutation.isLoading) {
       setSearchInstitutionLoading(true)
    } else {
      setSearchInstitutionLoading(false)
    }
  }, [getInstitutionsMutation.isLoading]);

  useEffect(() => {
    if (getCoursesMutation.isLoading) {
       setSearchCourseLoading(true)
    } else {
      setSearchCourseLoading(false)
    }
  }, [getCoursesMutation.isLoading]);

  return (
    <div className="fixed mt-8 md:mt-0 top-0 left-0 w-screen h-screen grid place-items-center bg-black bg-opacity-50">
      <div className="">
        <div className="min-h-[11rem] md:min-h-[12rem] w-[340px] md:w-[600px] bg-white rounded-[32px] flex flex-col justify-center p-8 md:p-16 relative">
          <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
            {t('add-education.title')}
          </h3>
          {isLoading ? (
            <div className="flex justify-center">
              <ScaleLoader color="#87AA4B" className="" />
            </div>
          ) : (
            <form onSubmit={createEducation}>
              {/* Institution Section */}
              <div className="mb-4 items-center relative">
                {searchInstitutionLoading && (
                  <div className="absolute text-md z-[10000000000000] bg-white w-full md:w-[360px] py-3 text-center top-[70px]">
                    <div className="w-full h-full flex justify-center items-center">
                      <ScaleLoader color="#87AA4B" className="" height={10} width={10}/>
                    </div>
                  </div>
                )}
                {isOthers ? (
                  <div className="relative">
                    <label htmlFor="institution-input" className="text-gray-500 mb-4 text-base font-medium">
                      {t('add-education.institution.label')}
                      <span className="text-red-500 required-dot">*</span>
                    </label>
                    <input 
                      id="institution-input"
                      placeholder={t('institution.placeholder')}
                      className={`rounded-lg flex-1 appearance-none border border-lightGrey w-full py-4 px-4 bg-customGrey text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-lightGrey focus:border-transparent`}
                      type="text" 
                      value={otherInstitution}
                      onChange={e => setOtherInstitution(e.target.value)}
                    />
                  </div>
                ) : (
                  <div>
                    <label
                      htmlFor="gender"
                      className="text-gray-500 mb-4 text-base font-medium"
                    >
                      {t('institution.name')}
                      <span className="text-red-500 required-dot">*</span>
                    </label>
                    <CustomDropdown 
                      width={'w-full'}
                      options={institutions}
                      value={
                          selectInstitutionId
                            ? { value: selectInstitutionId, label: selectInstitution } // Provide both value and label
                            : null
                        }
                        onChange={(selectedOption) => {
                          setSelectedInstitutionId(selectedOption?.value || "");
                          setSelectedInstitution(selectedOption?.label || "");
                          setInstitutionValid(!!selectedOption);
                        }}
                        onSearch={ (input) => {
                          setSearchInstitutionLoading(true)
                          handleSearch(input);
                        } }
                        placeholder={t('institution.select')}
                    />
                    {!institutionValid && (
                      <p className="text-red-500 text-md mt-1 text-left">
                        {t('errors.select-institution')}
                      </p>
                    )}
                  </div>
                )}
              </div>

              {/* Course and Degree Section */}
              <div className="mb-4 md:flex gap-x-4">
                <div className="mb-4 md:mb-0 w-full md:w-2/3 relative">
                  {searchCourseLoading && (
                    <div className="absolute text-md z-[10000000000000] bg-white w-full py-3 text-center top-[70px]">
                      <div className="w-full h-full flex justify-center items-center">
                        <ScaleLoader color="#87AA4B" className="" height={10} width={10}/>
                      </div>
                    </div>
                  )}
                  <label
                    htmlFor="gender"
                    className="text-gray-500 mb-4 text-base font-medium"
                  >
                    {t('add-education.course.label')}
                    <span className="text-red-500 required-dot">*</span>
                  </label>
                  <CustomDropdown
                    width={"w-full"}
                    options={courses}
                    value={
                      courseId ? { value: courseId, label: selectCourse } : null
                    }
                    onChange={(selectedOption) => {
                      setCourseId(selectedOption?.value || "");
                      setSelectedCourse(selectedOption?.label || "");
                      setCourseValid(!!selectedOption);
                    }}
                    placeholder={t('add-education.course.select')}
                    onSearch={(input) => {
                      setSearchCourseLoading(true)
                      handleCourseSearch(input);
                    }}
                  />
                  {!courseValid && (
                    <p className="text-red-500 text-md mt-1 text-left">
                      {t('add-education.validation.select-course')}
                    </p>
                  )}
                </div>
                <div className="mb-4 md:mb-0 w-full md:w-1/3">
                  <label
                    htmlFor="degree"
                    className="text-gray-500 mb-4 text-base font-medium"
                  >
                    {t('add-education.degree.label')}
                    <span className="text-red-500 required-dot">*</span>
                  </label>
                  <CustomDropdown
                    width={"w-full md:w-[180px]"}
                    options={
                      degrees?.length
                        ? degrees?.map((degree) => {
                            return { label: degree?.name, value: degree?.id };
                          })
                        : []
                    }
                    value={
                      degreeId
                        ? { value: degreeId, label: selectDegree } // Provide both value and label
                        : null
                    }
                    onChange={(selectedOption) => {
                      setDegreeId(selectedOption?.value || "");
                      setSelectedDegree(selectedOption?.label || "");
                      setDegreeValid(!!selectedOption);
                    }}
                    placeholder={t('add-education.degree.select')}
                  />
                  {!degreeValid && (
                    <p className="text-red-500 text-md mt-1 text-left">
                      {t('add-education.validation.select-degree')}
                    </p>
                  )}
                </div>
              </div>

              {/* Class of Degree Section */}
              <div className="mb-4 md:flex gap-x-4">
                <div className="w-full mb-4 md:mb-0">
                  <label
                    htmlFor="class_of_degree"
                    className="text-gray-500 mb-4 text-base font-medium"
                  >
                    {t('add-education.class-of-degree.label')}
                    <span className="text-red-500 required-dot">*</span>
                  </label>
                  <CustomDropdown
                    width={"w-full"}
                    options={
                      classOfDegrees?.length
                        ? classOfDegrees?.map((degree) => {
                            return { label: degree?.name, value: degree?.id };
                          })
                        : []
                    }
                    value={
                      classOfDegreeId
                        ? { value: classOfDegreeId, label: selectClassOfDegree } // Provide both value and label
                        : null
                    }
                    onChange={(selectedOption) => {
                      setClassOfDegreeId(selectedOption?.value || "");
                      setSelectedClassOfDegree(selectedOption?.label || "");
                      setClassOfDegreeValid(!!selectedOption);
                    }}
                    placeholder={t('add-education.class-of-degree.select')}
                  />
                  {!classofDegreeValid && (
                    <p className="text-red-500 text-md mt-1 text-left">
                      {t('add-education.validation.select-class')}
                    </p>
                  )}
                </div>
              </div>

              {/* Date Section */}
              <div className="mb-8 md:flex gap-x-4">
                <div className="w-full md:w-1/2 mb-4 md:mb-0">
                  <label
                    htmlFor="start_date"
                    className="text-gray-500 block mb-1 text-base font-medium"
                  >
                    {t('start-date')}
                    <span className="text-red-500 required-dot mr-2">*</span>
                  </label>
                  <DatePicker
                     selected={startDate}
                     placeholderText={t('add-education.dates.start.placeholder')}
                     dateFormat="dd/MM/yyyy"
                     className="border border-slate-300 block focus:border-primary active:border-primary py-4 px-3 rounded-lg text-sm text-slate-700 w-full"
                     //minDate={new Date()}
                     onChange={(value) => {
                      setStartDate(value);
                      setStartDateValid(true);
                    }}
                  />
                  {!startDateValid && (
                    <p className="text-red-500 text-md mt-1 text-left">
                      {t('add-education.validation.select-start-date')}
                    </p>
                  )}
                </div>
                <div className="w-full md:w-1/2 mb-4 md:mb-0">
                  <label
                    htmlFor="end_date"
                    className="text-gray-500 mb-1 block text-base font-medium"
                  >
                    {t('add-education.dates.end.label')}
                    <span className="text-red-500 required-dot">*</span>
                  </label>
                  <DatePicker
                     selected={endDate}
                     placeholderText={t('add-education.dates.end.placeholder')}
                     dateFormat="dd/MM/yyyy"
                     className="border border-slate-300 block focus:border-primary active:border-primary py-4 px-3 rounded-lg text-sm text-slate-700 w-full"
                     minDate={startDate}
                    onChange={(e) => {
                      setEndDate(e);
                      setEndDateValid(true);
                    }}
                  />
                  {!endDateValid && (
                    <p className="text-red-500 text-md mt-1 text-left">
                      {t('add-education.validation.select-end-date')}
                    </p>
                  )}
                </div>
              </div>

              {/* Buttons Section */}
              <div className="flex gap-x-10 justify-center">
                <button
                  type="button"
                  className="inline-flex justify-center rounded-md border border-primary shadow-sm px-8 py-2 md:px-16 md:py-4 bg-white text-sm md:text-lg font-medium text-primary sm:ml-3 sm:w-auto sm:text-sm mb-4 sm:mb-0"
                  onClick={() => closeModal(false)}
                >
                  {t('add-education.buttons.cancel')}
                </button>

                <button
                  type="submit"
                  disabled={createEducationLoading}
                  className="inline-flex justify-center rounded-md border border-none shadow-sm px-8 py-2 md:px-16 md:py-4 bg-primary text-sm md:text-lg font-medium text-white sm:ml-3 sm:w-auto sm:text-sm mb-4 sm:mb-0"
                >
                  {t('add-education.buttons.save')}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default AddEducation;
